// import { $sxhr } from "../../stempcore";
// import { resetURL, setUploadURL, setURL } from "../../stempcore/src/sbase";
// import URL from "../assets/conf/setting.json";
// // import URL from "../assets/conf/setting.json";
// // import $ from "jquery";
//
// resetURL(URL);
// setUploadURL(URL.template.api.ungateway.contentUrl);
// setURL(URL.template.api.gateway.general + "/");
//
// window.$sk.setApiUrl(URL.template.api.gateway.general);
// window.$sk.setUploadUrl(URL.sbaseUrl);

export default {
  //获取会议信息
  getArticle: info => {
    return window.$sk.$skxhr("article/getDetail", info);
  }, //获取文件列表
  getCommentList: info => {
    return window.$sk.$skxhr("comment/getList", info);
  },
  getFileList: info => {
    return window.$sk.$skxhr("file/getListForWeChat", info);
  },
  getLikeStatus: info => {
    return window.$sk.$skxhr("article/getLikeStatus", info);
  },
  like: info => {
    return window.$sk.$skxhr("article/like", info);
  },
  deleteComment: info => {
    return window.$sk.$skxhr("comment/front/delete", info);
  },
  commentLike: info => {
    return window.$sk.$skxhr("comment/like", info);
  },
  getNewForm: info => {
    return window.$sk.$skxhr("member/form/GetForNewForm", info);
  },
  createComment: info => {
    return window.$sk.$skxhr("comment/create", info);
  },
  downloadWithEmail: info => {
    return window.$sk.$skxhr("file/downloadWithEmail", info);
  },
  browse: info => {
    return window.$sk.$skxhr("article/browse", info);
  },
  getSubList: info => {
    return window.$sk.$skxhr("articleCategory/getSubList", info);
  },
  getArticleList: info => {
    return window.$sk.$skxhr("api/article/query", info);
  },
  browseCategory: info => {
    return window.$sk.$skxhr("api/article/category/interaction/browse", info);
  },
  getConfig: info => {
    return window.$sk.$skxhr("template/platform/instance/getConfig", info);
  },
  getRecommendedList: info => {
    return window.$sk.$skxhr("article/getRecommendedList", info);
  },
  getWechat: info => {
    return window.$sk.$skxhr("api/wechat/get", info);
  },
  getAppId: info => {
    return window.$sk.$skxhr("weChat/getAppId", info);
  }
};
